import React from 'react';
import { Users, TrendingUp, Car, PersonStanding } from 'lucide-react';

const visitorStats = {
  today: 89,
  trend: '+24%',
  byType: [
    { label: 'Residentes', count: 45, icon: PersonStanding },
    { label: 'Visitantes', count: 32, icon: Users },
    { label: 'Proveedores', count: 8, icon: Car },
  ],
};

export function VisitorsWidget() {
  return (
    <div className="space-y-4">
      {/* Main Stat */}
      <div className="flex items-center justify-between">
        <div>
          <p className="text-3xl font-bold text-gray-900">{visitorStats.today}</p>
          <p className="text-sm text-gray-500">Accesos hoy</p>
        </div>
        <div className="flex items-center gap-1 text-green-600 bg-green-50 px-3 py-1 rounded-full">
          <TrendingUp className="w-4 h-4" />
          <span className="text-sm font-medium">{visitorStats.trend}</span>
        </div>
      </div>

      {/* Breakdown */}
      <div className="space-y-2">
        {visitorStats.byType.map((type, index) => {
          const Icon = type.icon;
          return (
            <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
              <div className="flex items-center gap-2">
                <Icon className="w-4 h-4 text-gray-400" />
                <span className="text-sm text-gray-600">{type.label}</span>
              </div>
              <span className="font-semibold text-gray-900">{type.count}</span>
            </div>
          );
        })}
      </div>

      {/* Peak Hours */}
      <div className="pt-2">
        <p className="text-xs text-gray-500 mb-2">Horas pico</p>
        <div className="flex gap-1">
          {['8am', '12pm', '6pm', '9pm'].map((time, i) => (
            <div key={i} className="flex-1 text-center">
              <div 
                className="h-12 bg-[#36CCD8]/20 rounded-t-sm mx-1"
                style={{ height: `${[70, 85, 90, 40][i]}%` }}
              />
              <span className="text-xs text-gray-500">{time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default VisitorsWidget;
